// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QVNL","field":"styles_field__1SCIn","fieldCol":"styles_fieldCol__IXk36","diffCol":"styles_diffCol__xipv-","diff":"styles_diff__1zqLM"};